import b from 'b_';
import React from 'react';

import './results__table-block.scss';

interface OwnProps {
    header?: boolean;
    hidden?: boolean;
}

interface Props extends OwnProps, React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {}

const TableBlock = React.forwardRef(
    ({ children, header, hidden, onMouseLeave, ...otherProps }: Props, ref: (ref: HTMLDivElement | null) => void) => {
        return (
            <div
                className={b('results', 'table-block', { header, hidden })}
                onMouseLeave={onMouseLeave}
                ref={ref}
                {...otherProps}
            >
                {children}
            </div>
        );
    }
);

export default TableBlock;
